import { Map as ImmutableMap } from 'immutable';
import { FetchHubUsersActionTypes } from '../actions/HubUsersActions';
import HubUser from '../records/HubUser';
import { handleActions } from 'flux-actions';
const initialState = ImmutableMap();
export default handleActions({
  [FetchHubUsersActionTypes.SUCCESS](state, action) {
    return state.withMutations(map => {
      if (!action.payload) {
        return;
      }
      action.payload.data.forEach(hubUser => {
        if (!hubUser.id) {
          return;
        }
        map.set(hubUser.id, new HubUser(hubUser));
      });
    });
  }
}, initialState);